import { render } from "./PastDiagnosisRow.vue?vue&type=template&id=2c4ac636&ts=true"
import script from "./PastDiagnosisRow.ts?vue&type=script&lang=ts&external"
export * from "./PastDiagnosisRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__